<template>
  <div class="form-basic">
    <h4 class="title">基础信息</h4>
    <el-divider class="divider"></el-divider>
    <el-form :model="basicForm" :rules="rules" :label-position="'top'" ref="basicForm" :class="['media-form', 'media-' + mediaType]" size="small">
      <el-col :span="6">
        <el-form-item label="账号名称" prop="name" class="prop-item">
          <el-input v-model="basicForm.name" placeholder="输入账号名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="mediaType == MEDIA_TYPE.WECHAT || mediaType == MEDIA_TYPE.TAOBAO">
        <el-form-item label="账号ID" prop="code" class="prop-item">
          <el-input v-model="basicForm.code" placeholder="输入账号ID"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-else>
        <el-form-item label="账号链接" prop="url" class="prop-item">
          <el-input v-model="basicForm.url" placeholder="输入账号链接"></el-input>
        </el-form-item>
        <el-tooltip :content="linkTooltipList[mediaType]" placement="bottom" effect="light">
          <p class="link-tooltip">链接格式：{{ linkTooltipList[mediaType] }}</p>
        </el-tooltip>

      </el-col>
      <el-col :span="6" v-if="operateType === 'add' && (mediaType == MEDIA_TYPE.WECHAT || mediaType == MEDIA_TYPE.TAOBAO) || operateType === 'edit'">
        <el-form-item label="粉丝数" prop="fansNum" class="prop-item" :rules="operateType === 'edit' && mediaType != MEDIA_TYPE.WECHAT && mediaType != MEDIA_TYPE.TAOBAO ? [] : rules.fansNum">
          <el-input v-model="basicForm.fansNum" placeholder="输入粉丝数量" oninput="value=value.replace(/[^\d]/g,'')" :disabled="operateType === 'edit' && mediaType != MEDIA_TYPE.WECHAT&& mediaType != MEDIA_TYPE.KWAI && mediaType != MEDIA_TYPE.TAOBAO">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="operateType === 'add' && (mediaType == MEDIA_TYPE.WECHAT || mediaType == MEDIA_TYPE.TAOBAO) || operateType === 'edit'">
        <el-form-item label="性别" prop="gender" class="prop-item" :rules="operateType === 'edit' && mediaType != MEDIA_TYPE.WECHAT && mediaType != MEDIA_TYPE.TAOBAO ? [] : rules.gender">
          <el-select v-model="basicForm.gender" clearable placeholder="未选择" :disabled="operateType === 'edit' && mediaType != MEDIA_TYPE.WECHAT&& mediaType != MEDIA_TYPE.KWAI && mediaType != MEDIA_TYPE.TAOBAO">
            <el-option label="未知" :value="0"></el-option>
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="所在城市" prop="areaId" class="prop-item">
          <el-cascader v-model="basicForm.areaId" placeholder="选择所在地域" :options="regionList" clearable filterable change-on-select></el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="operateType === 'edit'">
        <el-form-item label="关联博主" prop="bloggerName" class="prop-item">
          <el-input disabled v-model="basicForm.bloggerName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="固定比例（%）" prop="fixedProportion" class="prop-item" >
          <el-input v-model="basicForm.fixedProportion" placeholder="输入固定比例" oninput="value=value.replace(/[^\d]/g,'')">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="mediaType == MEDIA_TYPE.REDBOOK">
        <el-form-item label="是否品牌合作人" prop="isBrandCooperation" class="prop-item">
          <el-select v-model="basicForm.isBrandCooperation" clearable placeholder="未选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="mediaType == MEDIA_TYPE.TIKTOK">
        <el-form-item label="星图平台上架" prop="isPlatformUp" class="prop-item">
          <el-select v-model="basicForm.isPlatformUp" clearable placeholder="未选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="mediaType != MEDIA_TYPE.WECHAT && mediaType != MEDIA_TYPE.TAOBAO">
        <el-form-item label="是否加入MCN" prop="isMcn" class="prop-item">
          <el-select v-model="basicForm.isMcn" clearable placeholder="未选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="mediaType == MEDIA_TYPE.WEIBO">
        <el-form-item label="UID" prop="uuid" class="prop-item">
          <el-input v-model="basicForm.uuid" placeholder="UID" :disabled="operateType === 'show'"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="mediaType == MEDIA_TYPE.REDBOOK">
        <el-form-item label="小红书号" prop="redBookNum" class="prop-item">
          <el-input v-model="basicForm.redBookNum" placeholder="输入小红书号" :disabled="operateType === 'show'"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="资源分类" prop="categoryList" class="prop-item">
          <div class="resourceTypes">
            <span v-for="(r, index) in categoryList" :key="r.categoryId" :id="r.categoryId" v-show="index < showMoreCategory" :class="getCheckStatus('categoryList', 'categoryId', r.categoryId) ? 'active' : ''"
              @click="onChangeCheckStatus('categoryList', 'categoryId', r.categoryId, r.categoryName)">{{r.categoryName}}</span>
            <span class="show-more-category" v-show="categoryList.length > 20 && showMoreCategory == 20" @click="showMoreCategory = 999999">
              更多
              <i class="el-icon-d-arrow-right"></i>
            </span>
            <span class="show-more-category" v-show="categoryList.length > 20 && showMoreCategory == 999999" @click="showMoreCategory = 20">
              <i class="el-icon-d-arrow-left"></i>收起
            </span>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="mediaType == MEDIA_TYPE.WECHAT || mediaType == MEDIA_TYPE.TAOBAO|| mediaType == MEDIA_TYPE.KWAI">
        <el-form-item label="头像上传" prop="avatar" class="avatar-upload-wrap">
          <el-upload class="avatar-uploader" :action="'https://upload-z2.qiniup.com'" :name="'avatar-image'" :show-file-list="false" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload"
            :accept="'image/gif, image/jpeg, image/jpg, image/png'">
            <img v-if="basicForm.avatar" :src="basicForm.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-else-if="mediaType != MEDIA_TYPE.WECHAT && mediaType != MEDIA_TYPE.TAOBAO && operateType === 'edit'">
        <el-form-item label="头像预览" prop="avatar" class="avatar-upload-wrap">
          <el-upload class="avatar-uploader upload-readonly" :action="'https://upload-z2.qiniup.com'" :name="'avatar-image'" :show-file-list="false" :accept="'image/gif, image/jpeg, image/jpg, image/png'" disabled>
            <img v-if="basicForm.avatar" :src="basicForm.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="合作品牌" prop="brandSide" class="prop-item">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8 }" placeholder="请输入合作品牌" maxlength="500" show-word-limit v-model="basicForm.brandSide">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="operateType === 'edit' && mediaType != MEDIA_TYPE.TAOBAO">
        <el-form-item label="账号简介" prop="description" class="prop-item">
          <el-input type="textarea" autosize placeholder="" v-model="basicForm.description" :disabled="mediaType != MEDIA_TYPE.KWAI">
          </el-input>
        </el-form-item>
      </el-col>
    </el-form>
  </div>
</template>

<script>
import validate from "@/util/validate";
import { mediaConfig } from "@/const/config/media";
import * as qiniu from "qiniu-js";
import { qiniuToken } from "@/api/index";
import { isExist } from "@/api/media/index";
import { getCategoryList, getRegionList } from "@/api/media/support";
export default {
  props: {
    mediaType: Number,
    operateType: String,
    initValue: Object,
  },
  data() {
    var validArea = (rule, value, callback) => {
      if (this.basicForm[rule.field].length == 0) {
        callback(new Error("请选择博主所在地"));
      } else {
        callback();
      }
    };
    var validID = (rule, value, callback) => {
      if (!validate.checkNull(value)) {
        let text = mediaConfig.getAppointed("media_en", this.mediaType);
        let text_ch = mediaConfig.getAppointed("media_ch", this.mediaType);
        if (!validate.checkMediaID(text, value)) {
          callback(new Error("请输入正确的" + text_ch + "ID"));
          return;
        }
        let obj =
          this.operateType == "edit" ? { mediaId: this.basicForm.mediaId } : {};
        obj.code = value;
        isExist(this.mediaType, obj)
          .then((res) => {
            console.log(res.data);
            if (!res.data) {
              callback(new Error("该账号已存在"));
            } else {
              callback();
            }
          })
          .catch((err) => {
            callback();
          });
        // callback();
      } else {
        callback();
      }
    };
    var validUrl = (rule, value, callback) => {
      if (!validate.checkNull(value)) {
        let text = mediaConfig.getAppointed("media_en", this.mediaType);
        let text_ch = mediaConfig.getAppointed("media_ch", this.mediaType);
        if (!validate.checkMediaUrl(text, value)) {
          callback(new Error("请输入正确的" + text_ch + "链接"));
          return;
        }
        let obj =
          this.operateType == "edit" ? { mediaId: this.basicForm.mediaId } : {};
        obj.code = value;
        isExist(this.mediaType, obj)
          .then((res) => {
            if (!res.data) {
              callback(new Error("该账号已存在"));
            } else {
              callback();
            }
          })
          .catch((err) => {
            callback();
          });
        // callback()
      } else {
        callback();
      }
    };
    var validCategory = (rule, value, callback) => {
      if (this.basicForm[rule.field].length > 6) {
        callback(new Error("最多可以选择6个分类"));
      } else if (this.basicForm[rule.field].length == 0) {
        callback(new Error("请选择分类"));
      } else {
        callback();
      }
    };
    var validFansNum = (rule, value, callback) => {
      if (!/^\d+$/.test(value)) {
        callback(new Error("请输入数字"));
      } else {
        if (parseInt(value) >= 1000000000) {
          callback(new Error("粉丝数不可超过10位数"));
        }
        callback();
      }
    };
    return {
      basicForm: {
        name: "",
        code: "",
        url: "",
        fansNum: "",
        gender: 0,
        areaId: "",
        isMcn: "",
        isBrandCooperation: "",
        isPlatformUp: "",
        categoryList: [],
        avatar: "",
        brandSide: "",
        redBookNum: "",
        uuid: "",
        fixedProportion:"",
      },
      rules: {
        name: [{ required: true, message: "请输入平台账号", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        isMcn: [
          { required: true, message: "请选择是否加入MCN", trigger: "change" },
        ],
        isBrandCooperation: [
          {
            required: true,
            message: "请选择是否品牌合作人",
            trigger: "change",
          },
        ],
        isPlatformUp: [
          { required: true, message: "请选择星图平台上架", trigger: "change" },
        ],
        url: [
          { required: true, message: "请输入账号链接", trigger: "blur" },
          { validator: validUrl, trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入账号ID", trigger: "blur" },
          { validator: validID, trigger: "blur" },
        ],
        fansNum: [
          { required: true, message: "请输入粉丝数量", trigger: "blur" },
          { validator: validFansNum, trigger: "blur" },
        ],
        categoryList: [
          { validator: validCategory, trigger: "change" },
          { required: true, message: "请选择资源分类", trigger: "change" },
        ],
        redBookNum: [
          { required: true, message: "请输入小红书号", trigger: "blur" },
        ],
        uuid: [{ required: true, message: "请输入UID", trigger: "blur" }],
      },

      regionList: [],
      categoryList: [],
      showMoreCategory: 20,

      linkTooltipList: {
        [this.MEDIA_TYPE.WECHAT]: "",
        [this.MEDIA_TYPE.WEIBO]: "https://weibo.com/u/xxxxxxxx",
        [this.MEDIA_TYPE.REDBOOK]:
          "https://www.xiaohongshu.com/user/profile/xxxxxxxx",
        [this.MEDIA_TYPE.TIKTOK]:
        // https://www.iesdouyin.com/share/user/xxxxxxxx?sec_uid=xxxxxxxx
          "https://v.douyin.com/xxxxxxxxx/（手机版）",
        [this.MEDIA_TYPE.BILIBILI]: "https://space.bilibili.com/xxxxxxx",
        [this.MEDIA_TYPE.KWAI]: "https://live.kuaishou.com/profile/xxxxxxxx",
        [this.MEDIA_TYPE.TAOBAO]: "",
      },
    };
  },
  created() {
    if (this.operateType !== "add") {
      this.initBasicForm(this.initValue);
    }
    this.initSupportOpts(["category", "area"]);
  },
  methods: {
    /**
     * 头像上传
     * @param file 需要上传的文件
     */
    beforeUpload(file) {
      let imgTypes = ["image/jpg", "image/jpeg", "image/gif", "image/png"];
      if (imgTypes.indexOf(file.type) === -1) {
        this.$message.warning("请上传正确格式图片，支持jpg/jpeg/gif/png");
        return;
      }
      if (file.size > 100 * 1024 * 1024) {
        this.$message.warning("图片文件大小不大于100M");
        return;
      }
      qiniuToken()
        .then((res) => {
          let that = this;
          var observable = qiniu.upload(file, Date.now() + file.name, res.data);
          observable.subscribe({
            next(res) {
              console.log("upload...", res); //res.total.percent;
            },
            error(error) {
              console.log("error", error);
            },
            complete: (complete) => {
              let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
              that.basicForm.avatar = qiniuBaseUrl + complete.key;
              that.$forceUpdate();
            },
          });
        })
        .catch((error) => {});
      return false;
    },
    // 上传图片成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    // 上传图片失败
    uploadError(res, file) {
      console.log("error", res, file);
    },
    /**
     * 改变选中状态
     * @param listType 是分类列表还是标签列表 string
     * @param idType 是categoryId还是tagId string
     * @param id id
     */
    onChangeCheckStatus(listType, idType, id, name, maxLen = 6) {
      var checked = this.getCheckStatus(listType, idType, id);
      var index = this.basicForm[listType].findIndex((v) => v[idType] == id);
      if (checked) {
        // 取消选中
        this.basicForm[listType].splice(index, 1);
      } else {
        // 选中
        if (this.basicForm[listType].length == maxLen) {
          this.$message.warning(`最大支持${maxLen}个分类标签`);
          return;
        }
        let obj = {};
        obj[idType] = id;
        this.basicForm[listType].push(obj);
      }
      this.$refs.basicForm.validateField(listType);
    },
    /**
     * 判断是否选中
     * @param listType 是分类列表还是标签列表 string
     * @param idType 是categoryId还是tagId string
     * @param id
     * @return 1选中/0未选中
     */
    getCheckStatus(listType, idType, id) {
      return this.basicForm[listType].findIndex((v) => v[idType] == id) !== -1;
    },
    /**
     * 初始化表单
     * @param initValue 从父组件接收到的账号基础信息
     */
    initBasicForm(initValue) {
      if (
        !initValue ||
        !initValue.mediaType ||
        !initValue.mediaId ||
        this.mediaType != initValue.mediaType
      ) {
        return;
      }
      this.basicForm = initValue;
      this.basicForm.categoryList = this.basicForm.categoryList || [];
      if (initValue.areaId && typeof initValue.areaId == "string") {
        this.basicForm.areaId = initValue.areaId.split(",");
        this.basicForm.areaId = this.basicForm.areaId.map((item, index) => {
          return parseInt(item);
        });
      }
    },
    initSupportOpts(list) {
      if (~list.indexOf("category")) {
        console.log("get category");
        getCategoryList({ mediaType: this.mediaType }).then((res) => {
          this.categoryList = res.data || [];
        });
      }
      if (~list.indexOf("area")) {
        console.log("get area");
        getRegionList().then((res) => {
          this.regionList = res.data || [];
        });
      }
    },
  },
  watch: {
    mediaType(newVal, oldVal) {
      this.$refs.basicForm.resetFields();
      this.initSupportOpts(["category"]);
      this.showMoreCategory = 20;
      this.basicForm.isMcn = "";
      this.basicForm.categoryList = [];
    },
    operateType(newVal, oldVal) {},
    initValue: {
      handler(newVal, oldVal) {
        if (this.operateType !== "add") {
          this.initBasicForm(newVal);
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.form-basic {
  position: relative;
  .title {
    margin: 5px 0;
    font-size: 14px;
  }
  .divider {
    margin: 8px 0 10px;
  }
  .prop-item {
    width: 90%;
    .el-select,
    .el-cascader {
      width: 100%;
    }
  }
  .resourceTypes {
    span {
      display: inline-block;
      width: 74px;
      text-align: center;
      border: #f0f0f0 1px solid;
      line-height: 20px;
      margin-right: 5px;
      border-radius: 5px;
      &:hover {
        cursor: pointer;
      }
      &.show-more-category {
        border: none;
        color: #409eff;
      }
    }
    .active {
      border-color: #409eff;
      background-color: #409eff;
      color: #fff;
    }
  }
  .media-form {
    overflow: hidden;
  }
  .link-tooltip {
    max-height: 16px;
    position: absolute;
    font-size: 12px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.media-form {
  &.media-2,
  &.media-3,
  &.media-4,
  &.media-5,
  &.media-6 {
    .el-col-6 {
      min-height: 108px;
    }
  }
}
</style>